import Lenis from 'lenis';
import gsap from '../../../gsap-public/esm/index.js';
import ScrollTrigger from '../../../gsap-public/esm/ScrollTrigger.js';

const log = (message, ...args) => {
  const timestamp = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', fractionalSecondDigits: 3 });
  console.log(`[${timestamp}] 🌊 ScrollManager: ${message}`, ...args);
};

class ScrollManager {
  constructor() {
    log('Constructor called');
    this.initSmoothScroll();
    this.bindScrollTrigger();
    log('Initialized');
  }

  initSmoothScroll() {
    // Scroll to top immediately before Lenis takes over
    window.scrollTo(0, 0);

    this.lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
      autoResize: true
    });

    // Integrate with GSAP ticker
    this.lenis.on('scroll', ScrollTrigger.update);

    gsap.ticker.add((time) => {
      this.lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }

  bindScrollTrigger() {
    const lenis = this.lenis;

    // Ensure ScrollTrigger works with Lenis
    ScrollTrigger.scrollerProxy(document.body, {
      scrollTop(value) {
        if (arguments.length) {
          lenis.scrollTo(value, { immediate: true });
        }
        return lenis.scroll;
      },
      getBoundingClientRect() {
        return {
          top: 0,
          left: 0,
          width: window.innerWidth,
          height: window.innerHeight
        };
      }
    });

    // Update ScrollTrigger on window resize
    ScrollTrigger.addEventListener('refresh', () => this.lenis.resize());

    // Refresh ScrollTrigger after layout settles
    ScrollTrigger.refresh();
  }

  scrollTo(target, options = {}) {
    if (typeof target === 'string') {
      const element = document.querySelector(target);
      if (element) {
        this.lenis.scrollTo(element, {
          offset: -100,
          duration: 1.5,
          ...options
        });
      }
    } else {
      this.lenis.scrollTo(target, options);
    }
  }

  stop() {
    log('STOPPING scroll');
    this.lenis.stop();
  }

  start() {
    log('STARTING scroll');
    this.lenis.start();
  }

  destroy() {
    log('Destroying');
    this.lenis.destroy();
    gsap.ticker.remove(this.lenis.raf);
  }
}

export default ScrollManager;
